export default "__VITE_PUBLIC_ASSET__bacb0798__"